<template>
  <div class="modal-container" v-if="visible">
    <div class="modal">
      <h4 class="modal__title">{{ $t("purchase") }}</h4>
      <a @click="hideModal"
        ><v-icon name="times" scale="1.6" class="modal__close-icon"
      /></a>
      <p class="modal__error">{{ errors }}</p>
      <form class="modal__form" @submit.prevent="submitForm">
        <div class="modal__form-item">
          <label class="modal__label">ISIN</label>
          <input
            type="text"
            class="modal__input modal__input_connected"
            style="width:190px"
            v-model="isin"
            required
          />
          <button
            type="button"
            class="modal__search-button button filled"
            @click="findItem"
          >
            {{ $t("search") }}
          </button>
        </div>
        <div class="modal__form-item">
          <label class="modal__label">{{ $t("issuer") }}</label>
          <input
            type="text"
            class="modal__input"
            disabled
            v-model="issuer"
            required
          />
        </div>
        <div class="modal__form-item">
          <label class="modal__label">{{ $t("security name") }}</label>
          <input
            type="text"
            class="modal__input"
            disabled
            v-model="name"
            required
          />
        </div>
        <div class="modal__form-item">
          <label class="modal__label">{{ $t("currency") }}</label>
          <input
            type="text"
            class="modal__input"
            disabled
            v-model="currency"
            required
          />
        </div>
        <div class="modal__form-item">
          <label class="modal__label">{{ $t("ask") }}</label>
          <input
            type="text"
            class="modal__input"
            disabled
            v-model="ask"
            required
          />
        </div>
        <div class="modal__form-item">
          <label class="modal__label">{{ $t("bid") }}</label>
          <input
            type="text"
            class="modal__input"
            disabled
            v-model="bid"
            required
          />
        </div>
        <div class="modal__form-item">
          <label class="modal__label">{{ $t("price") }}</label>
          <input type="text" class="modal__input" v-model="price" required />
        </div>
        <div class="modal__form-item">
          <label class="modal__label">{{ $t("amount") }}</label>
          <input type="text" class="modal__input" v-model="qty" required />
        </div>
        <div class="modal__form-item">
          <label class="modal__label">{{ $t("date of expiration") }}</label>
          <date-picker
            :lang="$t('short lang')"
            :range="false"
            class="controls__item controls__date-picker"
            value-type="format"
            v-model="duration"
            :placeholder="$t('select date')"
            format="DD.MM.YYYY"
            :not-before="new Date()"
          />
        </div>
        <textarea
          name="stemplate"
          class="hidden"
          id="stemplatemodal-buy-vp"
          ref="sign_buy_vp"
          v-model="signOrderBody"
        ></textarea>

        <div class="row">
          <button
            :disabled="!signed"
            v-bind:class="{ disabled: !signed }"
            type="submit"
            class="modal__submit-button button filled"
          >
            {{ $t("buy securities") }} ( {{ totalSum }} ₸ )
          </button>
          <button
            :disabled="signed"
            v-bind:class="{ disabled: signed }"
            v-on:click="xmlSign()"
            type="button"
            name="btn-sign"
            class="modal__submit-button button filled btn-eds"
            id="btn-edsmodal-buy-vp"
          >
            Подписать
          </button>
        </div>
      </form>
    </div>
  </div>
</template>
<script>
import { FhsAxios } from "../../services/axios";
import "vue-awesome/icons";
import Icon from "vue-awesome/components/Icon";
import user from "@/store/modules/user.js";
import Vue from "vue";
import i18n from "@/lib/vue-i18n/index";
import moment from "moment";
import DatePicker from "vue2-datepicker";
import FhsCookies from "../../services/cookies";

export default {
  props: {
    visible: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      userId: user.state.clientId,
      orderDate: "",
      errors: "",
      isin: "",
      issuer: "",
      name: "",
      currency: "",
      ask: "",
      bid: "",
      price: "",
      qty: 1,
      duration: "",
      orderType: 1,
      signOrderBody: "",
      signed: false,
      dealKind: 1,
      ticker: "",
      bondmarket: 1,
      PriceQuotation: 2,
      UserComments: "",
      profitability: "",
      MTOSenderID: 1
    };
  },
  watch: {
    isin: function() {
      if (this.signed === true) {
        this.signed = false;
        this.signOrderBody = "";
        console.log("need new sign");
      }
    },
    price: function() {
      if (this.signed === true) {
        this.signed = false;
        this.signOrderBody = "";
        console.log("need new sign");
      }
    },
    qty: function() {
      if (this.signed === true) {
        this.signed = false;
        this.signOrderBody = "";
        console.log("need new sign");
      }
    },
    duration: function() {
      if (this.signed === true) {
        this.signed = false;
        this.signOrderBody = "";
        console.log("need new sign");
      }
    }
  },
  components: {
    "v-icon": Icon,
    "date-picker": DatePicker
  },
  computed: {
    totalSum() {
      return this.qty * this.price;
    }
  },
  methods: {
    xmlSign: function() {
      if (this.checkForm()) {
        let signXml = this.getXml();
        return Vue.prototype.$signXmlCall(signXml, this, "signOrderBody");
      }
      return false;
    },
    getXml() {
      return (
        '<?xml version="1.0" encoding="UTF-8"?><vp-order>' +
        "<time>" +
        new Date().getTime() +
        "</time>" +
        "<isin>" +
        this.isin +
        "</isin>" +
        "<userId>" +
        this.userId +
        "</userId>" +
        "<orderDate>" +
        this.orderDate +
        "</orderDate>" +
        "<issuer>" +
        this.issuer +
        "</issuer>" +
        "<name>" +
        this.name +
        "</name>" +
        "<currency>" +
        this.currency +
        "</currency>" +
        "<ask>" +
        this.ask +
        "</ask>" +
        "<bid>" +
        this.bid +
        "</bid>" +
        "<price>" +
        this.price +
        "</price>" +
        "<qty>" +
        this.qty +
        "</qty>" +
        "<duration>" +
        this.duration +
        "</duration>" +
        "<orderType>" +
        this.orderType +
        "</orderType>" +
        "<dealKind>" +
        this.dealKind +
        "</dealKind>" +
        "<ticker>" +
        this.ticker +
        "</ticker>" +
        "<bondmarket>" +
        this.bondmarket +
        "</bondmarket>" +
        "<PriceQuotation>" +
        this.PriceQuotation +
        "</PriceQuotation>" +
        "<UserComments>" +
        this.UserComments +
        "</UserComments>" +
        "<profitability>" +
        this.profitability +
        "</profitability>" +
        "<MTOSenderID>" +
        this.MTOSenderID +
        "</MTOSenderID>" +
        "</vp-order>"
      );
    },
    findItem() {
      // sry
      FhsAxios.get("/reuters/securities/" + this.isin, {
        data: {}
      })
        .then(response => {
          let result = response.data.result;

          this.issuer = result.issuer.name;
          this.name = result.name;
          this.currency = result.currency;
        })
        .catch(e => {
          console.log(e);
        });

      //double sry
      FhsAxios.get("/reuters/quote/" + this.isin, {
        data: {}
      })
        .then(response => {
          let result = response.data.result;
          this.ask = result.ask;
          this.bid = result.bid;
          this.price = result.close;
        })
        .catch(e => {
          console.log(e);
        });
    },
    hideModal() {
      this.$emit("hideModal");
    },
    checkForm() {
      this.errors = "";
      let showError = false;
      if (!this.isin) {
        this.errors += " " + i18n.t("ISIN");
        showError = true;
      }
      if (!this.price) {
        this.errors += (this.errors.length > 0 ? ", " : " ") + i18n.t("price");
        showError = true;
      }
      if (!this.qty) {
        this.errors += (this.errors.length > 0 ? ", " : " ") + i18n.t("amount");
        showError = true;
      }
      if (!this.duration) {
        this.errors +=
          (this.errors.length > 0 ? ", " : " ") + i18n.t("date of expiration");
        showError = true;
      }
      if (showError === true) {
        this.errors = i18n.t("required field") + ":" + this.errors;
        return false;
      }
      return true;
    },
    submitForm() {
      let data = this._data;
      delete data.errors;
      delete data.signed;
      FhsAxios.post("orders/create-order", data)
        .then(response => {
          this.hideModal();
          // console.log(response.data);
          if (response.data.status == true) {
            alert("Приказ создан");
          } else {
            alert("Ошибка при создании приказа");
          }
        })
        .catch(e => {
          console.log(e);
        });
    },
    checkSign() {
      FhsAxios.post("utilities/eds/validate", {
        iin: user.state.iin,
        sign: btoa(this.signOrderBody)
      }).then(response => {
        if (response.data.status == 1) {
          console.log("sign validate!");
          console.log(Vue.signModel);
          Vue.signModel.signed = true;
        }
      });
    },
    format(value) {
      return moment(value).format("DD.MM.YYYY");
    }
  },
  getters: {}
};
</script>

<style scoped>
#btn-edsmodal-buy-vp {
  margin-left: 10px;
}

.row {
  padding: 10px;
  margin-left: 10px;
}

.modal {
  width: 448px;
}

.modal__error {
  list-style-type: none;
  color: red;
  text-align: right;
  margin-bottom: -20px;
}

.modal__form {
  margin-top: 30px;
  display: flex;
  flex-direction: column;
}

.modal__form-item {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.modal__form-item:not(:first-child) {
  margin-top: 15px;
}

.modal__label {
  max-width: 130px;
  font-size: 15px;
  margin: 0px 20px 0px 0px;
}

.modal__input {
  width: 250px;
  padding: 10px 12px;
  color: #222c44;
  border: 1px solid #acb5c5;
  border-radius: 5px;
}
.controls__date-picker {
  width: 275px;
}

.modal__submit-button {
  margin-top: 40px;
  padding: 15px 20px;
  align-self: flex-end;
  justify-self: flex-end;
}
.modal__search-button {
  padding: 10px;
  align-self: flex-end;
  justify-self: flex-end;
  border-bottom-left-radius: 0px;
  border-top-left-radius: 0px;
}
.modal__input_connected {
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
}
</style>
